<template>
  <div class="demo-alignment">

    <vs-popup classContent="popup-example" title="Session Time Out" :active.sync="popupActive2">
      <p>Your Session Has been Expired !</p>
      <br>
      <vs-button color="danger" type="filled">Logout</vs-button>
      <vs-button style="float: right" color="primary" type="filled">Continue
      </vs-button>


    </vs-popup>
  </div>
</template>

<script>
export default {
  data () {
    return {
      value1: '',
      value2: '',
      popupActive2: false,
      popupActive3: false
    }
  },
  methods: {
    sessionTimeOutAlert () {
      // console.log('reached')
      this.popupActive2 = true
    }

  },
  created () {
    this.interval = setInterval(() => this.sessionTimeOutAlert(), 300000)

  }
}
</script>
